import { DropDown, ValidatedDropDownList } from '@finbeat/react-toolkit';
import { BOValidatedDatePicker } from 'base-components/BOValidatedDatePicker/BOValidatedDatePicker';
import { t } from 'i18next';
import { PaymentsToClientsFilter as FilterType } from 'models/api/paymentsToClients';
import { Col, Row } from 'reactstrap';

const PaymentsToClientsFilter = ({ statuses }: { statuses: DropDown[] }) => {
    return (
        <>
            <Row>
                <Col>
                    <BOValidatedDatePicker<FilterType>
                        id="ds-start-date"
                        name="sd"
                        inputProps={{ label: t('BackOfficeStartDate') }}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <BOValidatedDatePicker<FilterType>
                        id="ds-end-date"
                        name="ed"
                        inputProps={{ label: t('BackOfficeEndDate') }}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <ValidatedDropDownList<FilterType> items={statuses} name="status" />
                </Col>
            </Row>
        </>
    );
};

export default PaymentsToClientsFilter;
